var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-responsive',{staticClass:"promo-slide overflow-visible mx-auto",style:({
    backgroundImage: !_vm.isLoading ? `url(${_vm.imageUrl})` : '',
    width: `${_vm.width}px`,
  }),attrs:{"aspect-ratio":_vm.aspectRatio}},[(_vm.isLoading)?_c('v-skeleton-loader',{attrs:{"type":"image"}}):_c(!!_vm.ctaUrl ? 'button' : 'div',{tag:"component",class:{
      'fill-height full-width d-flex flex-column align-stretch justify-end': true,
    },attrs:{"aria-label":!!_vm.ctaUrl ? _vm.ariaLabel : undefined},on:{"click":_vm.handleNavigation}},[_c('span',{class:{
        'd-block bg-overlay promo-content d-flex flex-column justify-end pl-4 pb-2 pa-8': true,
      }},[_c('span',{class:{
          'd-flex flex-row': true,
        }},[(_vm.logo)?_c('SanityImage',{class:{ 'd-block promo-logo': true },attrs:{"asset-id":_vm.logo.asset._ref,"alt":_vm.logo.alt}}):_vm._e()],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }